import React, { useState } from 'react';
import { ArrowRight, X, Plus, ShieldCheck } from 'lucide-react';
import { type Product } from './shopData';
function Seal({
  label
}: {
  label: string;
}) {
  return <div className="w-[72px] h-[72px] rounded-full border-2 border-white/70 flex flex-col items-center justify-center text-center px-1" data-id="element-2498">
      <ShieldCheck className="w-5 h-5 text-white/90 mb-0.5" data-id="element-2499" />
      <span className="text-[7px] font-bold uppercase tracking-[0.12em] leading-tight text-white/80" data-id="element-2500">
        {label}
      </span>
    </div>;
}
export function ProductInfoPanels({
  product
}: {
  product: Product;
}) {
  const [descOpen, setDescOpen] = useState(true);
  return <section className="max-w-7xl mx-auto px-6 mt-16 md:mt-20" data-id="element-2501">
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-6" data-id="element-2502">
        {/* LEFT — Ingredient Testing & Quality */}
        <div className="bg-[#16263A] text-white rounded-2xl p-8 md:p-10 flex flex-col" data-id="element-2503">
          <h3 className="text-2xl font-bold mb-4" data-id="element-2504">
            Ingredient Testing & Quality
          </h3>
          <p className="text-sm md:text-[15px] leading-relaxed text-white/85 mb-8" data-id="element-2505">
            Our products are made with raw materials sourced by suppliers that
            test each ingredient before release in an ISO: 17025 Certified Lab.
            Sourcing is done from manufacturers registered and inspected by the
            FDA. Our suppliers fully test every batch of sourced raw material
            using good manufacturing practices (cGMP). Internationally sourced
            ingredients undergo FTIR purity testing, microbiology contamination
            testing, ICP-MS heavy metal testing (Hg, As, Pb, Cd), and assay
            testing when applicable, after passing through U.S. Customs and FDA
            inspection.
          </p>
        </div>

        {/* RIGHT — Description */}
        <div className="bg-[#F9F9F9] border border-[#E5E5E5] rounded-2xl p-8 md:p-10" data-id="element-2506">
          <div className="flex items-center justify-between mb-5" data-id="element-2507">
            <h3 className="text-base font-bold text-[#1F1F1F]" data-id="element-2508">Description</h3>
            <button type="button" onClick={() => setDescOpen(v => !v)} aria-expanded={descOpen} aria-label={descOpen ? 'Collapse description' : 'Expand description'} className="text-[#9A9A90] hover:text-[#1F1F1F] transition-colors" data-id="element-2509">
              {descOpen ? <X className="w-5 h-5" data-id="element-2510" /> : <Plus className="w-5 h-5" data-id="element-2511" />}
            </button>
          </div>

          {descOpen && <div className="space-y-4 text-sm md:text-[15px] leading-relaxed text-[#5A5A5A] mb-2" data-id="element-2512">
              <p data-id="element-2513">{product.shortDescription}</p>
              <p data-id="element-2514">{product.whyEffective}</p>
            </div>}

          <details className="group border-t border-[#E5E5E5] mt-4" data-id="element-2515">
            <summary className="cursor-pointer list-none flex items-center justify-between py-5 text-base font-medium text-[#1F1F1F]" data-id="element-2516">
              Nutrition &amp; Supplement Facts
              <Plus className="w-5 h-5 text-[#9A9A90] transition-transform group-open:rotate-45" data-id="element-2517" />
            </summary>
            <div className="text-sm text-[#5A5A5A] leading-relaxed pb-6 space-y-2" data-id="element-2518">
              <p data-id="element-2519">
                Serving size: {product.dose} {product.doseUnit}.
              </p>
              <p data-id="element-2520">
                Made with clean, bioavailable ingredients — no artificial
                sweeteners, coloring, or preservatives. Full supplement facts
                panel is printed on the product label.
              </p>
            </div>
          </details>

          <details className="group border-t border-[#E5E5E5]" data-id="element-2521">
            <summary className="cursor-pointer list-none flex items-center justify-between py-5 text-base font-medium text-[#1F1F1F]" data-id="element-2522">
              Shipping &amp; Returns
              <Plus className="w-5 h-5 text-[#9A9A90] transition-transform group-open:rotate-45" data-id="element-2523" />
            </summary>
            <div className="text-sm text-[#5A5A5A] leading-relaxed pb-6 space-y-2" data-id="element-2524">
              <p data-id="element-2525">
                Orders ship within 1–2 business days. Standard delivery arrives
                in 3–5 business days.
              </p>
              <p data-id="element-2526">
                Not satisfied? Return any unopened product within 30 days for a
                full refund.
              </p>
            </div>
          </details>
        </div>
      </div>
    </section>;
}